var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRejectIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.65146 3.1415C9.84945 2.94901 10.166 2.95347 10.3585 3.15146L10.9835 3.79432L12.8585 5.72289C13.0472 5.91695 13.0472 6.22591 12.8585 6.41997L10.3585 8.9914C10.166 9.18939 9.84945 9.19385 9.65146 9.00136C9.45347 8.80886 9.44901 8.49231 9.6415 8.29432L11.3165 6.57143H6.625C5.18844 6.57143 4 7.77328 4 9.28571C4 10.7981 5.18844 12 6.625 12C6.90114 12 7.125 12.2239 7.125 12.5C7.125 12.7761 6.90114 13 6.625 13C4.60978 13 3 11.3237 3 9.28571C3 7.24774 4.60978 5.57143 6.625 5.57143H11.3165L9.6415 3.84854C9.44901 3.65055 9.45347 3.334 9.65146 3.1415Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRejectIcon);
export default __webpack_public_path__ + "static/media/reject-icon.9cd65c1455fd42b22ff1daa337282474.svg";
export { ForwardRef as ReactComponent };